function readConfig(windowKey: string, envKey: string): string {
  const runtimeValue = typeof window !== 'undefined' && (window as any)[windowKey];
  const value = runtimeValue || import.meta.env[envKey];
  if (!value) {
    throw new Error(
      `Missing ${envKey}. Set it in .env.local for local dev — see .env.example — or via env.js in a deployed environment.`
    );
  }
  return value;
}

export const MAPBOX_TOKEN = readConfig('__MAPBOX_TOKEN', 'VITE_MAPBOX_TOKEN');
export const MAPBOX_STYLE_URL = readConfig('__MAPBOX_STYLE_URL', 'VITE_MAPBOX_STYLE_URL');
